import { countries } from 'jsvat';

export const validateCountryVatNumber = (country: string) => {
  return countries.some((c) => c.codes[0] === country);
};
